module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Deleted-file-b0ec7dacdda07f3456ddf4c6356289ad.svg";